const register = {
  password_mismatch: '两次输入的密码不一致',
  email_invalid: '请输入有效的邮箱地址！',
  email_incorrect: '请输入正确的邮箱',
  title: '米通｜管理端注册',
  email_placeholder: '请输入邮箱',
  send_code: '发送验证码',
  password_again: '再次输入密码'
};

export default register;
